import React from "react";
import { Badge, Tag, Typography } from "antd";
import { InboxOutlined, MessageOutlined } from "@ant-design/icons";
import { capitalizeFirstLetter } from "../../../helpers/utility";

const UNREAD_COLOR = "#f04438";

const formatUnread = (count) => (count > 99 ? "99+" : count);

const NotificationPopover = ({ notifications, unreadCount, onItemClick }) => (
  <div className="notif-panel">
    <div className="notif-panel-header">
      <span className="notif-panel-title">Notifications</span>
      {unreadCount > 0 && (
        <Badge
          count={unreadCount}
          overflowCount={99}
          style={{ backgroundColor: UNREAD_COLOR }}
        />
      )}
    </div>
    {notifications.length === 0 ? (
      <div className="notif-panel-empty">
        <InboxOutlined className="notif-panel-empty-icon" />
        <Typography.Text type="secondary">You're all caught up</Typography.Text>
      </div>
    ) : (
      <ul className="notif-panel-list">
        {notifications.map((item) => {
          const isInternal = item?.chat_type === "internal";
          return (
            <li
              key={item.session_id}
              className="notif-item"
              onClick={() => onItemClick?.(item)}
            >
              <span
                className={`notif-item-icon notif-item-icon--${
                  isInternal ? "internal" : "external"
                }`}
              >
                <MessageOutlined />
              </span>
              <div className="notif-item-body">
                <div className="notif-item-top">
                  <span className="notif-item-title">IP: {item.ip_id}</span>
                  <Tag
                    className={`notif-item-tag notif-item-tag--${
                      isInternal ? "internal" : "external"
                    }`}
                    bordered={false}
                  >
                    {capitalizeFirstLetter(item?.chat_type)}
                  </Tag>
                </div>
                {item.last_message && (
                  <div className="notif-item-message">{item.last_message}</div>
                )}
              </div>
              {item.unread_count > 0 && (
                <span className="notif-item-count">
                  {formatUnread(item.unread_count)}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    )}
  </div>
);

export default NotificationPopover;
